import React from 'react'
import LandingNavBar from 'components/navbar/NavBar'
import CarouselAboutUs from 'components/CarouselAboutUs'
import Footer from 'components/Footer'
import LandingFooter from 'components/Footer/landingFooter'
import HeroSection from 'components/HeroSection'

const AboutUs = () => {
  return (
    <>
      <LandingNavBar />
      <HeroSection>
        <h1 class="font-[Good_Times] font-normal text-[40px] leading-[48px] tracking-[0] text-center align-middle capitalize">
          WHAT WE ARE & WHO WE ARE
        </h1>

        <h2 class="font-[Good_Times] font-normal text-[24px] leading-[40px] tracking-[0] text-center align-middle capitalize">
          Get to know our philosophy and <br /> our amazing team
        </h2>
      </HeroSection>
      <CarouselAboutUs />
      <LandingFooter />
    </>
  )
}

export default AboutUs
